import { asSequence2phdjljfh9jhx as asSequence } from './_Collections.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from './CollectionsKt.mjs';
import { Paire9pteg33gng7 as Pair } from '../Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from './collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asSequence_0(_this__u8e3s4) {
  return asSequence(_this__u8e3s4.d2());
}
function toList(_this__u8e3s4) {
  if (_this__u8e3s4.p1() === 0)
    return emptyList();
  var iterator = _this__u8e3s4.d2().m1();
  if (!iterator.n1())
    return emptyList();
  var first = iterator.o1();
  if (!iterator.n1()) {
    // Inline function 'kotlin.collections.toPair' call
    var tmp$ret$0 = new (Pair())(first.e2(), first.f2());
    return listOf(tmp$ret$0);
  }
  var result = ArrayList().u(_this__u8e3s4.p1());
  // Inline function 'kotlin.collections.toPair' call
  var tmp$ret$1 = new (Pair())(first.e2(), first.f2());
  result.v(tmp$ret$1);
  do {
    // Inline function 'kotlin.collections.toPair' call
    var this_0 = iterator.o1();
    var tmp$ret$2 = new (Pair())(this_0.e2(), this_0.f2());
    result.v(tmp$ret$2);
  }
   while (iterator.n1());
  return result;
}
//region block: exports
export {
  asSequence_0 as asSequence2lno4vpru4ldl,
  toList as toList2zksu85ukrmi,
};
//endregion

//# sourceMappingURL=_Maps.mjs.map
